var Giant = Giant || {};

;(function($, window, document, undefined) {

    var pluginName = 'showIf',
        $window = $(window),
        defaults = {
            field: null,
            value: '',
            valueType: 'string', // TODO string | integer | boolean
            remove: false,
            parent: null,
            detach: false, // detaches children when not visible
            condition: '==' // '==', '!='
        };

    function ShowIf(element, options) {
        this.scope = element;
        this.$scope = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    ShowIf.prototype = {

        init: function() {
            var self = this;

            // jquery fails on {} in id attribute
            var field = document.getElementById(this.options.field.replace('#',''));

            if (!field) {
                field = $('[name="' + this.options.field + '"]');
            }

            this.$field = $(field);
            if ('iCheck' in $.fn) {
                this.$field.on('ifChanged', self.render.bind(self));
            } else {
                this.$field.on('change', self.render.bind(self));
            }

            if (!$.isArray(this.options.value)) {
                this.options.value = [this.options.value];
            }

            this.options.value = this.options.value.map(function(value) {
                return self.formatValue(value);
            });

            this.$buffer = null;

            this.render();

            return this;
        },

        render: function() {
            var resolution = false,
                fieldValue = this.formatValue(this.$field.val());

            if (this.$field.attr('type') === 'checkbox') {
                fieldValue = this.$field.is(':checked') ? 'checked' : '';
            }

            if (this.$field.attr('type') === 'radio') {
                fieldValue = this.$field.filter(':checked').val();
            }

            switch (this.options.condition) {
                case '==':
                    resolution = this.options.value.indexOf(fieldValue) > -1 ? true : false;
                break;

                case '!=':
                    resolution = this.options.value.indexOf(fieldValue) > -1 ? false : true;
                break;

                default:
                    throw new Error('ShowIf: Unknown condition');
            }

            if (resolution) {
                this.show();
            } else {
                this.hide();
            }
        },

        attach: function() {
            if (this.$buffer !== null) {
                this.$buffer.appendTo(this.$scope);
                this.$buffer = null;
                this.$scope.trigger('change:dom');
            }
            return this;
        },

        detach: function() {
            if (this.$buffer === null) {
                this.$buffer = this.$scope.children().detach();
            }
            return this;
        },

        show: function() {
            if (this.options.detach) {
                this.attach();
            }
            this.$scope.show();
            return this;
        },

        hide: function() {
            this.$scope.hide();
            if (this.options.detach) {
                this.detach();
            }
            return this;
        },

        formatValue: function(value) {
            var response = value;
            switch (this.options.valueType) {
                case 'integer':
                    response = parseInt(value, 10);
                break;
                case 'boolean':
                    response = !!value;
                break;
                default: // string
                    response = value + '';
            }

            return response;
        }
    };

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin-' + pluginName)) {

                // parse data-options
                var data = $(this).data(),
                    options = {},
                    settings = '';

                if (pluginName in data) {
                    settings = data[pluginName];
                    // pass options
                    if ($.type(settings) === 'object') {
                        options = settings;
                    }

                    // parse shortcut and create options
                    if ($.type(settings) === 'string' && settings !== '') {
                        var params = data[pluginName].match(/(.*)(!=|==)(.*)/);
                        options.field = params[1];
                        options.condition = params[2];
                        options.value = params[3].split(',');
                    }
                }

                $.each(defaults, function(key, value) {
                    var option = pluginName + key.substr(0,1).toUpperCase() + key.substr(1);

                    if (option in data) {
                        options[key] = data[option];
                    }
                });

                $.data(this, 'plugin-' + pluginName, new ShowIf(this, options));
            }
        });
    };

    $.fn[pluginName].defaults = defaults;

    // listen to change event and init self
    $(document).on('change:dom', function(event) {
        $('[data-show-if]', event.target).showIf();
    });
    $('[data-show-if]').showIf();

    Giant.ShowIf = ShowIf;

})(jQuery, window, document);